import script from "./MessagesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessagesList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInfiniteScroll,QSpinner});
